import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Create from "@/pages/Create";
import ContentStudio from "@/pages/ContentStudio";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import ErrorBoundary from "@/components/ErrorBoundary";
import WhatsAppButton from "@/components/WhatsAppButton";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#FBFBF9] text-zinc-950">
      <Navbar />
      {children}
      <WhatsAppButton />
    </div>
  );
}

function AppRouter() {
  return (
    <Routes>
      {/* The sales page lives on its own hostname and Pages project, so this app
        never serves it. Opening the root starts the app; ProtectedRoute sends a
        signed-out visitor to /login. */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/app" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="Dashboard">
              <Shell><Dashboard /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/create"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="Photo Studio">
              <Shell><Create /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/content"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="Content Studio">
              <Shell><ContentStudio /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="History">
              <Shell><History /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="Profile">
              <Shell><Profile /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute admin>
            <ErrorBoundary label="Admin">
              <Shell><Admin /></Shell>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
